'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import { TableCell, TableRow } from '@repo/ui';
import Link from 'next/link';
import type { JSX } from 'react';
import { isCollectionComplete } from './is-collection-complete';
import {
  ClipStep,
  CropStep,
  ExtractStep,
  GrammarStep,
  ManualStep,
  MatchStep,
  MissingStep,
  PopulateStep,
  PublishStep,
  RejectedChallengeStep,
  RejectedClipStep,
  SrtStep,
  TranslateStep,
  TriagedStep,
  UploadStep,
  VideoStep,
} from './steps';

interface IPipelineRowProps {
  item: ICollectionPipelineStatusV3;
  hasVideo?: boolean;
}

export function PipelineRow({ item, hasVideo }: IPipelineRowProps): JSX.Element {
  const complete = isCollectionComplete(item, hasVideo);
  return (
    <TableRow>
      <TableCell className="font-medium max-w-[200px] truncate" title={item.collectionPath}>
        <Link
          href={`/sys/collections/${item.collectionId}`}
          className={`hover:underline ${complete ? 'font-semibold text-green-600' : ''}`}
        >
          {item.title}
        </Link>
      </TableCell>
      <TableCell className="text-xs text-muted-foreground">{item.type}</TableCell>
      <SrtStep item={item} />
      <VideoStep hasVideo={hasVideo ?? false} />
      <MatchStep item={item} />
      <GrammarStep item={item} />
      <ClipStep item={item} />
      <ExtractStep item={item} />
      <ManualStep item={item} />
      <PopulateStep item={item} />
      <TranslateStep item={item} />
      <CropStep item={item} />
      <TriagedStep item={item} />
      <MissingStep item={item} />
      <RejectedClipStep item={item} />
      <RejectedChallengeStep item={item} />
      <UploadStep item={item} />
      <PublishStep item={item} />
    </TableRow>
  );
}
